"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

import { SITE_NAME } from "@shared/constants";

import TrustedForm from "@client/components/trusted-form";

interface Props {
  baseUrl?: string;
  stepName?: string;
  message?: string;
}

export default function FormConsents({
  baseUrl = "",
  stepName = "",
  message,
}: Props) {
  const [btnText, setBtnText] = useState("");

  useEffect(() => {
    const $btnText = document.querySelector(".button-new__text")?.innerHTML;

    setBtnText($btnText || "");
  }, []);

  const consentPreface = (
    <p>
      By clicking{" "}
      <b className="uppercase" data-spec-cta-text>
        {btnText}
      </b>{" "}
      above, you understand and agree to the following:
    </p>
  );

  let stepConsents;

  const emailConsents = (
    <>
      {consentPreface}
      <p>
        You agree to {SITE_NAME}'s{" "}
        <Link href={`${baseUrl}/terms-of-service`} target="_blank">
          Terms of Service
        </Link>
        ,{" "}
        <Link href={`${baseUrl}/privacy-policy`} target="_blank">
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link href={`${baseUrl}/esign-consent`} target="_blank">
          E-Sign Consent
        </Link>
        .
      </p>
      <p>
        You agree to our{" "}
        <Link
          href={`${baseUrl}/credit-authorization-agreement`}
          target="_blank"
        >
          Credit Authorization Agreement
        </Link>{" "}
        and authorize {SITE_NAME} and its{" "}
        <Link href={`${baseUrl}/providers`} target="_blank">
          Providers
        </Link>
        , under the Fair Credit Reporting Act (FCRA) to obtain your consumer
        report, credit profile, or other credit information associated with you
        from any consumer reporting agency in order to verify your identity and
        assess your eligibility for financial services and products.
      </p>
    </>
  );

  const phoneNumberConsents = (
    <>
      {consentPreface}
      <p>
        You are providing your express written consent for{" "}
        {SITE_NAME == "American Loan Assistance"
          ? `${SITE_NAME} (CPC Marketing)`
          : SITE_NAME}{" "}
        and its{" "}
        <Link href={`${baseUrl}/providers`} target="_blank">
          Providers
        </Link>{" "}
        to call and/or text you at the number above, including through automated
        means (e.g. autodialing and pre-recorded messaging) for transactional
        purposes as well as for marketing purposes such as to offer you products
        and services that may serve your financial needs.
      </p>
    </>
  );

  switch (stepName) {
    case "email":
      stepConsents = emailConsents;
      break;

    case "phone":
    case "phone-number":
      stepConsents = phoneNumberConsents;
      break;

    default:
      break;
  }

  if (stepConsents) {
    return (
      <>
        <div
          className={message ? "form__consents -mt-4" : "form__consents"}
          data-spec-lead-form-consents
        >
          {stepConsents}
        </div>
        <TrustedForm />
      </>
    );
  }
}
